import { httpClient, postProcessUpsert } from "@genai/http-client";
import {
  ApiOrganization,
  CreateOrganizationForm,
  Organization,
} from "../model";

export function createOrganization(
  createOrganizationForm: CreateOrganizationForm,
) {
  return  httpClient("/organizations", {
    method: "POST",
    body: JSON.stringify(createOrganizationForm),
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then(postProcessUpsert<ApiOrganization>)
    .then((organization) => organization as Organization);
}
